import HeaderDesktop from "../HeaderDesktop";
import { Main } from "./styles";
import TitlePage from "../../pages/TitlePage";
import ProjectsPage from "../../pages/ProjectsPage";
import AboutMePage from "../../pages/AboutMePage";
import ContactPage from "../../pages/ContactPage";
import { useState } from "react";

const DesktopApp = () => {
  const [page, setPage] = useState(0);
  return (
    <>
      <HeaderDesktop page={page} setPage={setPage} />
      <Main page={page}>
        <div className="colored-box">
          <TitlePage page={page} />
          <ProjectsPage page={page} />
          <AboutMePage />
        </div>
        <ContactPage />
      </Main>
    </>
  );
};

export default DesktopApp;
